import app from "/src/app/app.module";
import Tendant from "../../models/tendant";


app.controller('company_details',
    function ($scope, $timeout, msgBus, $auth, vxUtils, sweet, toastr) {
        var vm = this;

        vm.subjectPlaceholder = vxUtils.loc('ADD_DESCRIPTION_PLACEHOLDER');
        vm.depots = [];
        vm.selectedDepot = null;
        vm.adressCpi = {};

        vm.addMessage = function () {
            var m = new Tendant();
            m.name = vm.title;
            vm.title = '';
            vm.selectedDepot = m;
            vm.saveDepot(true);
        };

        vm.removeColor = function () {
            vm.selectedDepot.color= null;
        }

        vm.deleteDepot = function () {
            sweet.show({
                title: vxUtils.loc('CONFIRMDELETION'),
                text: vxUtils.loc('REMOVECOMPANY'),
                type: 'success',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: vxUtils.loc('YES'),
                closeOnConfirm: true
            }, function () {
                $auth.deleteCompany(function () {
                    var i = vm.depots.indexOf(vm.selectedDepot);
                    vm.depots.splice(i, 1);
                    vm.selectedDepot = vm.depots[vm.depots.length - 1];
                    vm.adressCpi.adress = vm.selectedDepot;
                }, vm.selectedDepot.idTendant);
            });
        };

        vm.saveDepot = function (isNew) {
            $auth.postCompany(function (result) {
                if (isNew) {
                    vm.depots.splice(0, 0, result);
                    vm.adressCpi.adress = result;
                    vm.selectedDepot = result;
                }
                toastr.success(vxUtils.loc('SUCCES'), vxUtils.loc('CHANGESUCCESFULL'));
                // update cache localstorage
                $auth.getAllCompanies(null,null,true);
            }, vm.selectedDepot);
        };

        vm.getDepots = function () {
            $auth.getAllCompanies(function (result) {

                vm.depots = result;
                if (vm.depots.length > 0) {
                    vm.selectedDepot = vm.depots[0];
                    vm.adressCpi.adress = vm.selectedDepot;
                }
            }, true);

        };

        vm.getDepots();
    });